import { render, staticRenderFns } from "./DetailImg.vue?vue&type=template&id=f824c080&scoped=true&"
import script from "./DetailImg.vue?vue&type=script&lang=js&"
export * from "./DetailImg.vue?vue&type=script&lang=js&"
import style0 from "./DetailImg.vue?vue&type=style&index=0&id=f824c080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f824c080",
  null
  
)

component.options.__file = "DetailImg.vue"
export default component.exports